import dayjs from 'dayjs';
import { businessNumberRegex, phoneRegex } from './regex';

function extractNumberFromString(input: string): number {
  if (!input) return 0;
  const numberString: string = input.replace(/[^\d.-]/g, '');
  const result: number = parseFloat(numberString);
  return isNaN(result) ? 0 : result;
}

function addToHyphenToPhoneNumberInstantly(value: string): string {
  const phoneNumber = value.replace(/\D/g, '');

  if (phoneNumber.length >= 4 && phoneNumber.length < 8) {
    return phoneNumber.slice(0, 3) + '-' + phoneNumber.slice(3);
  } else if (phoneNumber.length >= 8) {
    return (
      phoneNumber.slice(0, 3) +
      '-' +
      phoneNumber.slice(3, 7) +
      '-' +
      phoneNumber.slice(7)
    );
  } else {
    return phoneNumber;
  }
}

function addCommaToNumberInstantly(value: string | number | undefined): string {
  let numStr: string = '';
  if (!value) return '0';
  if (typeof value === 'number') numStr = value.toString();
  if (typeof value === 'string')
    numStr = Number(value.replace(/\D/g, '')).toString();

  const formattedNumStr = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return formattedNumStr || '0';
}

function addToHyphenToKorNumber(value: string): string {
  const phoneNumber = value.replace(/\D/g, '');

  let formattedNumber;
  if (phoneNumber.length === 10) {
    // Handle local phone numbers
    if (phoneNumber.startsWith('02')) {
      // Format 02-XXXX-XXXX
      formattedNumber = phoneNumber.replace(
        /(\d{2})(\d{4})(\d{4})/,
        '$1-$2-$3',
      );
    } else {
      // Format 0XX-XXXX-XXXX
      formattedNumber = phoneNumber.replace(
        /(\d{3})(\d{3})(\d{4})/,
        '$1-$2-$3',
      );
    }
  } else if (phoneNumber.length === 11) {
    // Handle mobile phone numbers
    formattedNumber = phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  } else {
    formattedNumber = phoneNumber;
  }

  return formattedNumber;
}

export const formatter = {
  PHONE: (value: string) => {
    if (!value) return '-';
    return value.replace(/-/g, '').replace(phoneRegex, '$1-$2-$3');
  },
  KOR_NUMBER: (value: string) => addToHyphenToKorNumber(value),
  NUM_HYPHEN_INSTANTLY: (value: string) =>
    addToHyphenToPhoneNumberInstantly(value),
  NUM_COMMA_INSTANTLY: (value: string | number | undefined) =>
    addCommaToNumberInstantly(value),
  STRING_TO_NUM: (value: string) => extractNumberFromString(value),
  NUM_COMMA: (value?: string | number) =>
    !isNaN(Number(value)) ? Number(value).toLocaleString() : 0,
  BUSINESS_NUMBER: (value: string) => {
    if (!value) return '-';
    return value
      .replace(/-/g, '')
      .substring(0, 10)
      .replace(businessNumberRegex, '$1-$2-$3');
  },
  DATE: (value?: string | Date, format?: string) => {
    return value ? dayjs(value).format(format || 'YYYY-MM-DD HH:mm:ss') : '-';
  },
};
